module.exports = __webpack_public_path__ + "static/media/like-icon.52e34e57.svg";